import { Model as o } from "../../../../model.js";
class e extends o {
  constructor(r) {
    super(), this.days = r.days, this.startHour = r.startHour, this.endHour = r.endHour;
  }
}
export {
  e as LoyaltyProgrammeValidityScheduleModel
};
//# sourceMappingURL=loyaltyProgrammeValiditySchedule.model.js.map
